<template lang="pug">
#IngresarPago
  b-button(
    variant="action"
    @click="showModalPayment()"
  )
    | Ingresar Pago
  ModalPayment(:showModal="showModal" :item="this.dataOv"  @close="onClose" )
</template>
<script>
import ModalPayment from '../../ModalPayment.vue';

export default {
  name: 'IngresarPago',
  components: {
    ModalPayment
  },
  props: {
    dataOv: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false

    }
  },
  methods: {
    showModalPayment() {
      console.log('showModalPayment', this.dataOv)
      this.showModal = true;
    },
    onClose() {
      this.$emit('reloadAll');
      this.showModal = false;
    }
  }

}
</script>
